<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3">
          <card>
            <template slot="header">
              <h4 class="card-title">Accedi</h4>
            <p>Inserisci le credenziali</p>
            <form class="login-form">
              <div class="row">
                <div class="col-12">
                  <fg-input type="text"
                    label="Username"
                    placeholder="Username"
                    v-model="username">
                  </fg-input>
                </div>
                <div class="col-12">
                  <fg-input type="password"
                    label="Password"
                    placeholder="Password"
                    v-model="password">
                  </fg-input>
                </div>
                <div class="col-12">
                  <p-checkbox
                    v-model="stay_connected">
                      <label class="control-label">
                      Resta connesso
                      </label>
                  </p-checkbox>
                </div>
                <div class="col-12">
                  <button type="submit" :disabled="loading" class="btn btn-info btn-fill float-right" @click.prevent="login">
                    Accedi
                  </button>
                </div>
              </div>
            </form>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3" style="padding:0px 30px;">
          <a href="#/user-recovery">Password dimenticata?</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        loading: false,
        username: '',
        password: '',
        stay_connected: false
      }
    },
    methods: {
      login: function (event) {
        var me = this
        me.$data.loading = true
        var username = this.$data.username
        var password = this.$data.password
        var stayConnected = this.$data.stay_connected
        var callBackFn = function (success) {
          if (success === false) {
            me.$data.loading = false
          }
        }
        this.$root.login(username, password, stayConnected, callBackFn)
      }
    }
  }

</script>
<style>
.login-form .form-check {
  padding-left: 0px;
}
.login-form .form-check .form-check-label{
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralViews/LogIn.vue